import { useTheme } from '@emotion/react'

import {
  SanofiMonoLogo,
  SmartcarMonoLogo,
  LensOnlineMonoLogo,
} from '@segment/matcha/components/CompanyLogos/CompanyMono'
import { SanofiLogo, SmartcarLogo, LensOnlineLogo } from '@segment/matcha/components/CompanyLogos/Company'

const testimonialData = () => {
  const theme = useTheme()
  return [
    {
      company: `sanofi`,
      text: (
        <>
          “Previously, we would work with our data by moving it, then using it. Now, with Segment, we can use data while
          we move it. The big benefit of Segment is not only its ETL capabilities to move data from point A to point B
          but Segment is also able to unify data quickly in the warehouse before we can send the data to campaign
          tools."
        </>
      ),
      name: `Rick Troiani`,
      position: `Director of Omni-Channel Engagement Architecture`,
      logo: <SanofiMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <SanofiLogo />,
      logoName: `Sanofi`,
      extendedRate: `93%`,
      extendedText: `time saved adding new data sources`,
      extendedLink: `/customers/sanofi/`,
    },
    {
      company: `smartcar`,
      text: (
        <>
          “Building a user-friendly API isn’t always easy—especially if you want to appeal to your users and their
          users. Thanks to Twilio Segment, we can focus on both areas in one go, and give our team the chance to measure
          and evaluate the things they feel are most important.”
        </>
      ),
      name: `Sanketh Katta`,
      position: `CTO and co-founder, Smartcar`,
      logo: <SmartcarMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <SmartcarLogo />,
      logoName: `Smartcar`,
      extendedRate: `22%`,
      extendedText: `improvement in developer application conversions`,
      extendedLink: `/customers/smartcar/`,
    },
    {
      company: `lens-online`,
      text: (
        <>
          “While our previous tech stack, including a CRM, SAP, Zendesk, etc. supported our early growth, it wasn't
          enough for our future ambitions. We needed to not just understand but anticipate our customer's needs. This
          realization led us to Twilio Segment, moving beyond traditional CRMs to a 360-degree view of customers,
          integrating every customer interaction and preference with a customer data platform.”
        </>
      ),
      name: `Pascal`,
      position: `CMO & CDO, LensOnline`,
      logo: <LensOnlineMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <LensOnlineLogo />,
      logoName: `Fender`,
      extendedRate: `15%`,
      extendedText: `reduction in marketing spend`,
      extendedLink: `/customers/lens-online/`,
    },
  ]
}

export { testimonialData }
